class HeaderView {
  _parentElement = document.querySelector(`.header`);
  _data;

  render(data) {
    this._data = data;
    // console.log(this._data);

    const markup = this._generateMarkup();

    this._clear();
    this._parentElement.insertAdjacentHTML(`afterbegin`, markup);
  }

  _generateMarkup() {
    return `
        <a href="${this._data.url}">
          <img
            crossorigin="anonymous"
            src="${this._data.profilPicUrl}"
            class="profile_pic"
          />
        </a>

        <div class="user_info">
          <a href="${this._data.url}">
            <h1 class="github_link">${this._data.name}</h1>
          </a>

          <a
            href="https://github.com/MCCP96/codewars"
          >
            <p class="github_link">Daily Coding Challenges</p>
          </a>
        </div>
          `;
  }

  _clear() {
    this._parentElement.innerHTML = ``;
  }
}

export default new HeaderView();
